import { Observable } from 'rxjs';
import { StorageParameters } from '../storage.service';
import { ApiBase } from './api.base';

export class AssetApi extends ApiBase {
  model = 'assets';

  public createContainer(name: string): Observable<{ container: string }> {
    return this.http.post<{ container: string }>(
      this.buildUrl(),
      { name },
      {
        headers: this.setHeaders({
          Authorization: this.getStorage().getItem(
            StorageParameters.AccessTokenId
          ),
        }),
      }
    );
  }

  public getContainer(container: string): Observable<{ container: string }> {
    return this.http.get<{ container: string }>(this.buildUrl(container), {
      headers: this.setHeaders({
        Authorization: this.getStorage().getItem(
          StorageParameters.AccessTokenId
        ),
      }),
    });
  }

  public upload(
    container: string,
    file: any,
    fileName: string
  ): Observable<{ result: any }> {
    const formData = new FormData();
    formData.append('file', file, fileName);
    return this.http.post<{ result: any }>(
      this.buildUrl(container, 'upload'),
      formData,
      {
        headers: this.setHeaders({
          Authorization: this.getStorage().getItem(
            StorageParameters.AccessTokenId
          ),
        }),
      }
    );
  }

  public uploadFiles(
    files: Array<any>,
    container: string
  ): Observable<{ result: any }> {
    const formData = new FormData();
    files.forEach((file, index) => {
      const name = file.name;
      formData.append(`file${index + 1}`, file, name);
    });
    return this.http.post<{ result: any }>(
      this.buildUrl(container, 'upload'),
      formData,
      {
        headers: this.setHeaders({
          Authorization: this.getStorage().getItem(
            StorageParameters.AccessTokenId
          ),
        }),
      }
    );
  }

  public download(container: string, fileName: string) {
    return this.http.get<any>(this.buildUrl(container, 'download', fileName), {
      headers: this.setHeaders({
        Authorization: this.getStorage().getItem(
          StorageParameters.AccessTokenId
        ),
      }),
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }
}
